<template>
  <div>
    <b-modal
      id="feedback-modal"
      ref="feedback-modal-ref"
      hide-footer
      scrollable
      title-html="<h2>Feedback</h2>"
    >
    <p class="mt-4">When leaving a review of us on Trustpilot, your e-mail address {{email}} is used in
        encrypted form by Trustpilots integrity team to verify you as a unique user to authenticate
        your review.
    </p>
    
    <iframe  id="trustpilot-frame" :src="feedbackUrl"></iframe>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    email:null
  },
  data() {
    return { feedbackUrl: "" };
  },
  methods: {
    showModal(url) {
      this.feedbackUrl = url
      this.$refs["feedback-modal-ref"].show();
    }
  }
};
</script>

<style lang="scss">
  #trustpilot-frame {
    border: 0px;
    margin: auto;
    width: 100%;
    height: 700px; 
  }
</style>
